export default {
	init() {
    $('#keyword').on('input', function() {
      if ($(this).val().length) {
        $("#datafetch").show();
      } else {
        $("#datafetch").hide();
      }
    });
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlossary.js